import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';
import { isMobile } from 'mobile-device-detect';

import ModalStep from '../common/ModalStep';
import { verifyCustomerPhone, openStartOrderScreen, getOldestActiveLoyalty, resetErrMsg, getCaptcha } from '../../actions/index';
import SMSConfirmationCommon from '../../pwa-app/components/profile/login/SMSConfirmationCommon';
import UserIconSVG from '../../pwa-app/components/common/svgComponents/UserIconSVG';
import { ARABIC } from "../../utils/Constants";

class SmsConfirmationScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            code: null,
            submitBtnDisabled: true
        };

        this.goBack = this.goBack.bind(this);
    }

    componentWillMount() {
        this.applyTheme();
        this.props.getCaptcha();
    }

    componentWillUnmount() {
        this.props.resetErrMsg();
    }

    componentDidMount() {

        document.getElementsByClassName('modal-header')[0].remove();

        const isMobileView = window.outerWidth <= 800;
        if (isMobileView) {
            document.getElementsByClassName('modal-body')[0].style.minHeight = '480px';
        }
    }

    goBack() {
        if (this.props.isCheckoutLogin) {
            const path = '/menu-screen';
            this.props.openStartOrderScreen(path);
        } else {
            this.props.history.goBack();
        }
    }

    renderModalHeader() {
        const { loginTextStyle, imageStyle, imageStyleRTL } = styles;
        const { type, primaryColor, secondaryColor } = this.props.customerThemes.selectedTheme;
        const isArabic = this.props.language === ARABIC;

        // Render the close button for start order modal on this screen when opening it from menuScreen
        let closeButtonShowClass = '';
        if (this.props.isCheckoutLogin) closeButtonShowClass = ' from-menu-screen';

        return (
            <Fragment>
                <div className='start-order-header-container'>
                    <Button className="start-order-custom-back-button" onClick={() => this.goBack()}>
                        <span className="backButtonIcon"><MaterialIcon icon="navigate_before" color="#000" size={32} /></span>
                        <span style={{ fontWeight: 300 }}>{i18n.t('common:buttons.backBtn')}</span>
                    </Button>
                    <div style={isArabic ? { margin: '0 auto', fontSize: 20, textAlign: 'center', display: 'flex', alignItems: 'center' } : { margin: '0 auto', fontSize: 20, textAlign: 'center' }}>
                        <UserIconSVG
                            width={23} height={23}
                            fill={type === 'DARK' ? secondaryColor : primaryColor}
                            style={isArabic ? imageStyleRTL : imageStyle} />
                        <span style={loginTextStyle}>{i18n.t('screens:smsConfirmationScreen.confirmation')}</span>
                    </div>
                    <div style={{ width: 90, textAlign: isArabic ? 'left' : 'right' }}>
                        <Button className={`start-order-custom-close-button ${closeButtonShowClass}`} onClick={() => this.props.toggle()}>
                            <MaterialIcon icon="close" color="#000" size={18} />
                        </Button>
                    </div>
                </div>
            </Fragment>
        );
    }

    renderModalBody() {
        const isArabic = this.props.language === ARABIC;
        
        return (
            <React.Fragment>
                {this.renderModalHeader()}
                <SMSConfirmationCommon
                    styles={styles}
                    customerThemes={this.props.customerThemes}
                    customer={this.props.customer}
                    verifyCustomerPhone={this.props.verifyCustomerPhone}
                    isPwa={false}
                    startOrder={this.props.startOrder}
                    goBack={this.goBack.bind(this)}
                    getOldestActiveLoyalty={this.props.getOldestActiveLoyalty}
                    isArabic={isArabic}
                    brand={this.props.brand}
                    resetErrMsg={this.props.resetErrMsg}
                    loadCaptcha={this.props.getCaptcha}
                    shoppingCart={this.props.shoppingCart}
                />
            </React.Fragment>
        );
    }

    applyTheme() {
        let customizedStyles = JSON.parse(JSON.stringify(styles));
        const { primaryColor, fontWeight, startOrderFontSize, mainTextColor, chefNoteBackground, primaryFontColor } = this.props.customerThemes.selectedTheme;

        customizedStyles.heading.fontSize = startOrderFontSize;
        customizedStyles.subHeading.color = mainTextColor;
        customizedStyles.input.fontWeight = fontWeight;
        customizedStyles.submitBtn.backgroundColor = primaryColor;
        customizedStyles.numberStyle.color = primaryColor;
        customizedStyles.input.backgroundColor = chefNoteBackground;
        customizedStyles.loginTextStyle.color = primaryFontColor;
        styles = customizedStyles;
        return styles;
    }

    render() {
        const startOrderStyles = isMobile ? { overflowY: 'auto', overflowX: 'hidden', height: window.innerHeight } : {}

        return (
            <AvForm className="start-order" style={startOrderStyles}>
                <ModalStep
                    onToggle={this.props.toggle}
                    renderBody={this.renderModalBody()}
                    styles={styles}
                    customerThemes={this.props.customerThemes}
                />
            </AvForm>
        );
    }
}


const mapStateToProps = state => {
    return {
        customer: state.customer,
        customerThemes: state.customerThemes,
        startOrder: state.startOrder,
        language: state.storeLocalStorage.language,
        brand: state.brand,
        shoppingCart: state.shoppingCart
    };
};

export default connect(mapStateToProps, { 
    verifyCustomerPhone, 
    openStartOrderScreen, 
    getOldestActiveLoyalty, 
    resetErrMsg,
    getCaptcha 
})(SmsConfirmationScreen);

let styles = {
    modalBody: {
        textAlign: 'center',
        padding: 0,
        minHeight: '480px',
        backgroundColor: '#ffffff'
    },
    modalFooter: {},
    login: {
        fontSize: 22,
        marginLeft: 30,
        marginRight: 12
    },
    loginTextStyle: {
        marginLeft: -10,
        verticalAlign: 'middle'
    },
    heading: {
        fontSize: 22,
        margin: 'auto',
        textAlign: 'center'
    },
    subHeading: {
        fontSize: 14,
        color: '#939393',
        marginBottom: 4
    },
    inputGroup: {
        margin: 'auto',
        height: 50,
        marginBottom: 10
    },
    input: {
        height: 50,
        // borderRadius: 4,
        backgroundColor: '#e9ecef',
        textAlign: 'center',
        paddingLeft: 35
    },
    numberStyle: {
        color: '#61B522',
        // fontWeight: 700
    },
    submitBtn: {
        height: 50,
        borderRadius: 0,
        width: '100%',
        marginBottom: 38,
        backgroundColor: '#61B522',
        border: 'none'
    },
    submitBtnDisabled: {
        height: 50,
        borderRadius: 0,
        width: '100%',
        marginBottom: 38,
        backgroundColor: '#a8a8a8',
        border: 'none'
    },
    headerColumn: {
        paddingLeft: 0,
        width: 72
    },
    secondCol: {
        margin: 'auto'
    },
    thirdCol: {
        margin: 'auto'
    },
    phoneIconStyle: {
        position: 'absolute',
        padding: '8px 5px',
        marginLeft: 5,
        zIndex: 1
    },
    phoneIconStyleRTL: {
        position: 'absolute',
        padding: '8px 5px',
        marginRight: 5,
        zIndex: 1
    },
    imageStyle: {
        marginRight: 16
    },
    imageStyleRTL: {
        marginLeft: 5
    },
    centredItem: {
        margin: '0 auto',
        fontSize: 20,
        textAlign: 'center',
        paddingRight: 55
    },
    modalCustomSubmitBody: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '50px'
    },
    phoneNumberHeadingCol: { 
        height: 57, 
        maxHeight: 57, 
        minHeight: 57 
    },
    marginAuto: {
        margin: 'auto',
        position: 'relative',
        bottom: 20,
        top: 0
    }
}